/* import __COLOCATED_TEMPLATE__ from './not-found.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-not-found';

export default Component.extend({
  session: service(),
  currentUser: readOnly('session.currentUser'),

  tagName: '',
  classNames: [CLASS_NAME],
  CLASS_NAME,

  /** @param {String} error */
  error: null,

  /** @type {String} */
  buttonText: computed('error', function () {
    return `View Bug #${this.get('error')}`;
  }),
});
